import { memo } from 'react';
import ItemsGrid from '@wconcept/wconcept-ui-renewal/components/atoms/ItemsGrid';
import ItemsScrollBar from '@wconcept/wconcept-ui-renewal/components/atoms/ItemsScrollBar';
import ContTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ContTitle';
import ToggleNotice from '@wconcept/wconcept-ui-renewal/components/molecules/_notice/ToggleNotice';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface CustomColorType {
  bgColor?: string;
  textColor?: string;
}

type ColorType = 'white' | 'black' | CustomColorType | string;

interface IProps {
  title?: string;
  subTitle?: string;
  benefitItems?: React.ReactNode;
  noticeList?: string[];
  colorType?: ColorType;
  isDesktop?: boolean;
  onNoticeToggle?: (active: boolean) => void;
}

const PaymentBenefitSection = ({
  title,
  subTitle,
  benefitItems,
  noticeList,
  colorType = 'white',
  isDesktop,
  onNoticeToggle,
}: IProps) => {
  const isCustomColor = typeof colorType === 'object';
  const customColors = isCustomColor ? colorType : undefined;

  const cName = classNameBind([
    'event-payment-benefit',
    !isCustomColor ? `bg-type-${colorType}` : '',
  ]);

  return (
    <S.PaymentBenefitSection
      className={cName}
      $bgColor={customColors?.bgColor}
      $textColor={customColors?.textColor}
    >
      <ContTitle
        title={title}
        subTitle={subTitle}
        titleColor={customColors?.textColor}
        subTitleColor={customColors?.textColor}
      />

      {isDesktop ? (
        <ItemsGrid perView={4} colGap={2} rowGap={2} className="benefit-list">
          {benefitItems}
        </ItemsGrid>
      ) : (
        <ItemsScrollBar perView={2} colGap={2} className="benefit-list">
          {benefitItems}
        </ItemsScrollBar>
      )}

      {noticeList && Array.isArray(noticeList) && (
        <ToggleNotice
          onNoticeToggle={onNoticeToggle}
          noticeList={noticeList}
          titleColor={customColors?.textColor}
          noticeColor={customColors?.textColor}
          hideBullet
        />
      )}
    </S.PaymentBenefitSection>
  );
};

export default memo(PaymentBenefitSection);
